export default {
      id: "ok-usage",
      viewBox: "0 0 13 10",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#ok",
      toString: function () {
        return this.url;
      }
    }